import React from "react";
import HeroSection from "../components/HeroSection";

// Home is intentionally thin — all data fetching lives in HeroSection.
// If more sections are added to the home page later, import them here.
const Home = () => {
  return (
    <>
      <HeroSection />
    </>
  );
};

export default Home;
